import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { ArtistPreReleasesPage } from '~/modules/artist-roster/components/ArtistDetails/ArtistPreReleasesPage';
import { RosterPage } from '~/modules/artist-roster/components/Roster/RosterPage';
import { TrackDetailsPage } from '~/modules/artist-roster/components/TrackDetails/TrackDetailsPage';

import { ArtistBenchmarksPage } from './components/ArtistDetails/ArtistBenchmarksPage';
import { ArtistLayout } from './components/ArtistDetails/ArtistLayout';
import { ArtistReleasesPage } from './components/ArtistDetails/ArtistReleasesPage';

/**
 * Top-level router combining module-level routers
 */
function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route path="*" element={<RosterPage />} />
          <Route path=":partyId" element={<ArtistLayout />}>
            <Route index element={<Navigate to="releases" replace />} />
            <Route path="releases" element={<ArtistReleasesPage />} />
            <Route path="pre-releases" element={<ArtistPreReleasesPage />} />
            <Route path="campaigns" element={<ArtistBenchmarksPage />} />

            {/* TODO: remove the redirect from ':partyId/tracks' path to ':partyId/releases' */}
            <Route
              path="tracks"
              element={<Navigate to="../releases" replace />}
            />
          </Route>
          <Route path=":partyId/:familyId" element={<TrackDetailsPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'RosterRouter';

export { Router };
